import { apiClient } from '@/lib/api-client'
import type { TemplateMeal, RecipeResponse } from './types'

export function getTemplateMeals(): Promise<TemplateMeal[]> {
  return apiClient.get<TemplateMeal[]>('/api/v1/templates')
}

export function addTemplateMeal(templateMealId: string): Promise<RecipeResponse> {
  return apiClient.post<RecipeResponse>(`/api/v1/templates/${templateMealId}/add`, {})
}
